import { HttpClient } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';

import { CmsServerService } from 'src/app/services/jsonrpc/cms-server.service';

import { FileUploadComponent } from '../file-upload/file-upload.component';

@Component({
  selector: 'app-login-hero-exchange',
  templateUrl: './login-hero-exchange.component.html',
  styleUrls: ['./login-hero-exchange.component.scss']
})
export class LoginHeroExchangeComponent {
  @ViewChild(FileUploadComponent) private fileUpload: FileUploadComponent;

  public uploading = false;
  public uploadProgress = {};
  public hasImage = true;
  public heroUrl = 'public/login-hero.jpg';

  public imageFormats = {
    'image/png': 'image',
    'image/jpeg': 'image',
    'image/webp': 'image'
  };

  private readonly filename = 'login-hero.jpg';
  private readonly maxWidth = 2000;

  constructor(private server: CmsServerService, private http: HttpClient) {}

  public async uploadHero(files: { title: string; file: File }[]) {
    const { title, file } = files[0];
    this.uploading = true;

    try {
      const blob = await this.resize(file);
      const res = await this.server.mediaPublicUpload({ filename: this.filename });
      await this.http
        .put(res.url, blob, {
          reportProgress: true,
          observe: 'events'
        })
        .toPromise();

      this.uploadProgress[title] = 100;
      // the file keeps its name, so a new query makes the browser load the new version
      this.heroUrl = `public/${this.filename}?t=${Date.now()}`;
      this.hasImage = true;
    } finally {
      this.uploadProgress = {};
      this.uploading = false;
      this.fileUpload.reset();
    }
  }

  public onPreviewError() {
    this.hasImage = false;
  }

  /** Scales the image down to maxWidth and re-encodes it as JPEG so large photos stay small. */
  private resize(file: File): Promise<Blob> {
    return new Promise((resolve, reject) => {
      const url = URL.createObjectURL(file);
      const image = new Image();

      image.onload = () => {
        URL.revokeObjectURL(url);
        const scale = Math.min(1, this.maxWidth / image.width);
        const canvas = document.createElement('canvas');
        canvas.width = Math.round(image.width * scale);
        canvas.height = Math.round(image.height * scale);

        const ctx = canvas.getContext('2d');
        // JPEG has no transparency
        ctx.fillStyle = '#fff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

        canvas.toBlob(blob => (blob ? resolve(blob) : reject(new Error('Could not convert the image'))), 'image/jpeg', 0.85);
      };
      image.onerror = () => {
        URL.revokeObjectURL(url);
        reject(new Error('Could not read the image'));
      };
      image.src = url;
    });
  }
}
